import { createContext, useEffect, useState } from "react";
import { Hanko, register } from "@teamhanko/hanko-elements";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiClient } from "../../client/ApiClient";

interface HankoContextType {
  hanko?: Hanko
}

export const HankoContext = createContext<HankoContextType>({
  hanko: undefined
})

export const HankoProvider = (props: { children: React.ReactNode }) => {
  const [hanko, setHanko] = useState<Hanko | undefined>()

  useEffect(() => {
    register(window.REACT_APP_LOGIN_PROVIDER_URL, { shadow: false, injectStyles: true }).then(
      result => setHanko(result.hanko)
    ).catch((error) => {
        console.log(error)
      })
  }, []);

  return <HankoContext.Provider value={{ hanko }}>
    {props.children}
  </HankoContext.Provider>
}